// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1gESj","buttons":"SendReceipts_buttons__1WeIX","email":"SendReceipts_email__2psdm","bookApptTitle":"SendReceipts_bookApptTitle__2kt2c"};